import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

export const selectRuleIndex = (store: StoreSchema) => store.ruleCard.index
export const selectRuleSchema = (store: StoreSchema) => store.ruleCard.schema
export const selectRuleConfig = (store: StoreSchema) => store.ruleCard.config

export const selectRuleFullPath = (store: StoreSchema) =>
    store.ruleCard.fullPath

export const selectRuleIsChecked = (store: StoreSchema) =>
    store.ruleCard.isChecked

export const selectIsRuleUnsaved = (store: StoreSchema) =>
    store.ruleCard.isUnsaved

export const selectRuleInvalidFields = (store: StoreSchema) =>
    store.ruleCard.invalidFields

export const selectRuleConfigBit = (path: string[]) =>
    createSelector([selectRuleConfig], (config) => {
        return path.reduce((configAcc, pathBit) => {
            return configAcc?.[pathBit]
        }, config)
    })
